import React from "react";
import { BrowserRouter as Router } from "react-router-dom";
import { createStore, applyMiddleware } from "redux";
import { composeWithDevTools } from "redux-devtools-extension";
import { Provider } from "react-redux";
import { allReducers } from "./redux/reducers";
import Amplify from "aws-amplify";
import thunk from "redux-thunk";
import ReactDOM from "react-dom";
import App from "./App";

const store = createStore(
  allReducers,
  composeWithDevTools(applyMiddleware(thunk))
);

if (process.env.REACT_APP_BUILD_ENV === "dev") {
  Amplify.configure({
    Auth: {
      mandatorySignId: true,
      region: process.env.REACT_APP_CONFIGJSON_REGION_DEV,
      userPoolId: process.env.REACT_APP_CONFIGJSON_USER_POOL_ID_DEV,
      userPoolWebClientId: process.env.REACT_APP_CONFIGJSON_APP_CLIENT_ID_DEV,
    },
  });
} else if (process.env.REACT_APP_BUILD_ENV === "test") {
  Amplify.configure({
    Auth: {
      mandatorySignId: true,
      region: process.env.REACT_APP_CONFIGJSON_REGION_TEST,
      userPoolId: process.env.REACT_APP_CONFIGJSON_USER_POOL_ID_TEST,
      userPoolWebClientId: process.env.REACT_APP_CONFIGJSON_APP_CLIENT_ID_TEST,
    },
  });
} else if (process.env.REACT_APP_BUILD_ENV === "demo") {
  Amplify.configure({
    Auth: {
      mandatorySignId: true,
      region: process.env.REACT_APP_CONFIGJSON_REGION_DEMO,
      userPoolId: process.env.REACT_APP_CONFIGJSON_USER_POOL_ID_DEMO,
      userPoolWebClientId: process.env.REACT_APP_CONFIGJSON_APP_CLIENT_ID_DEMO,
    },
  });
} else if (process.env.REACT_APP_BUILD_ENV === "prod") {
  Amplify.configure({
    Auth: {
      mandatorySignId: true,
      region: process.env.REACT_APP_CONFIGJSON_REGION_PROD,
      userPoolId: process.env.REACT_APP_CONFIGJSON_USER_POOL_ID_PROD,
      userPoolWebClientId: process.env.REACT_APP_CONFIGJSON_APP_CLIENT_ID_PROD,
    },
  });
}

ReactDOM.render(
  <Provider store={store}>
    <Router>
      <App />
    </Router>
  </Provider>,
  document.getElementById("root")
);
